import { rest } from 'msw'
import data from '../data/resampled-dataset.json'

export default [
  /**
   * 長期トレンド
   */
  rest.get('/swc-api/resampled-datasets/:id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    const timeFrom = req.url.searchParams.get('time_from')
    const timeTo = req.url.searchParams.get('time_to')
    const asFreq = req.url.searchParams.get('as_freq')
    const splitBy = req.url.searchParams.get('split_by')
    let result = data[0]
    
    if (asFreq == 'D' && splitBy == 'Y') {
        result = data[1]
    }

    if (asFreq == 'D' && splitBy == 'M') {
        result = data[2]
    }

    if (asFreq == 'D' && splitBy == 'W') {
      result = data[3]
  }

    return res(
      ctx.status(200),
      ctx.json(result)
    )
    
  }),
]
